const configItem = {
    normal: {
        listLayout: 'ItemListDefaultLayout',
        paginationLayout: 'PaginationDefaultLayout',
        filterLayout: 'ItemFilterDefaultLayout',
        listApiParamSet: {
            ip:1
        },
        paginationType: 'pagination',
        pageRow: 10,
    },
    normalCreate: {
        optionLayouts: ['ItemInputLayout'],
        subFunc: 'createItem',
        parsingData: {
            country: 'c_idx',
            name: 'i_name',
            price: 'i_price',
            priceOrg: 'i_price_org',
            cycleDay: 'if_cycle_day',
        },
        detailApiParamSet: {
            ip: 0,
        },
        createApiParamSet: {},
        resultAlertTxt: '상품이 등록되었습니다.',
        directUrl: 'back',
    },
    normalUpdate: {
        optionLayouts: ['ItemInputLayout'],
        subFunc: 'updateItem',
        parsingData: {
            no: 'i_idx',
            name: 'i_name',
            price: 'i_price',
            priceOrg: 'i_price_org',
            cycleDay: 'if_cycle_day',
        },
        detailApiParamSet: {
            ip: 0,
        },
        createApiParamSet: {},
        resultAlertTxt: '상품이 수정되었습니다.',
        directUrl: '',
    },
}

export default {
    methods: {
        returnItemConfig(type) {
            return configItem[type];
        }
    },
    filterConfig: {
        na: {
            type: 'query',
            classname: 'searchInput',
        },
        cr: {
            type: 'between',
            classname: 'filterDate',
        },
        cid: {
            type: 'match',
            classname: 'filterCountry'
        }
    }
}